var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"modal-bg",on:{"click":_vm.hide}},[_c('div',{staticClass:"fadeInLeft animated modal",on:{"click":_vm.stopPropagation}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }